const theme = {
  color: { ROSA: "#fb2660", AZUL_ESCURO: "#242833", CINZA_CLARO: "#F5F5F5" },
}

export default theme
